import MagicLinkSent from '../../components/login/MagicLinkSent';

const MagicLinkSentPortal = (props) => (
  <MagicLinkSent {...props} />
);

export default MagicLinkSentPortal;
